<template>
    <div id="app">
        <!--<router-view/>-->
        <b-container fluid>
            <div>
                <h1>LED Pattern Controller</h1>
                <b-form>
                    <b-form-group id="isRunningGroup"
                                  label="Start / Stop the LEDs"
                                  label-for="set-running-state">
                        <b-button id="set-running-state"
                                  type="button"
                                  v-bind:variant="buttonClass"
                                  @click="stopStart(status)"
                                  block>{{ buttonLabel }}</b-button>
                    </b-form-group>
                    <b-form-group id="speedGroup"
                                  label="LED Speed"
                                  label-for="range-speed">
                        <b-form-input id="range-speed" class="range" type="range" min="0" max="980" v-model="status.speed"
                                      @change="updateSpeed(status, $event)">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group label="LED Pattern">
                        <b-form-radio-group id="led-pattern"
                                            buttons
                                            button-variant="outline-primary"
                                            v-model="status.pattern"
                                            :options="options"
                                            name="radioOpenions"
                                            size="lg"
                                            @change="updatePattern(status, $event)">
                        </b-form-radio-group>
                    </b-form-group>
                </b-form>
            </div>
        </b-container>
    </div>
</template>

<script>
	import firebase from 'firebase';
	import 'bootstrap/dist/css/bootstrap.css'
	import 'bootstrap-vue/dist/bootstrap-vue.css'
	// import axios from 'axios';

	let db, app;
	// let statusRef = [];

	// const setup = async () => {
	const config = {
		apiKey: "AIzaSyC4AZKr-m1RbfV_ahJzBwgCyDtCJ3gdIDE",
		authDomain: "pi-leds.firebaseapp.com",
		databaseURL: "https://pi-leds.firebaseio.com",
		projectId: "pi-leds",
		storageBucket: "pi-leds.appspot.com",
		messagingSenderId: "262688155056"
	};
	app = firebase.initializeApp(config);
	// const tokenData = await axios.get("http://localhost:5001/pi-leds/us-central1/auth");
	// const token = tokenData.data;
	// console.log(token);
	// const userData = await firebase.auth().signInWithCustomToken(token);
	db = app.database();
	// }
	const statusRef = db.ref("status");

	export default {
		name: 'app',
		data() {
			return {
				options: [
                    {text: '1', value: 1},
					{text: '2', value: 2},
					{text: '3', value: 3},
					{text: '4', value: 4}
                ]
			}
			// 	statusBasic: {
			// 		isRunning: false,
			// 		pattern: 1,
			// 		speed: 0
			// 	}
		},
        computed: {
			buttonClass: function() {
				let defaultClass = "success";
				if(this.status.isRunning) defaultClass = "danger";
				return defaultClass;
            },
			buttonLabel: function() {
				let defaultLabel = "Start";
				if(this.status.isRunning) defaultLabel = "Stop";
				return defaultLabel;
			}
        },
		firebase: function() {
			return {
				status: {
					source: statusRef,
					asObject: true
				}
			};
		},
		methods: {
			updateSpeed(status, value) {
				this.$firebaseRefs.status.child('speed').set(value);
			},
            stopStart(status) {
				const newState = !status.isRunning;
				this.$firebaseRefs.status.child('isRunning').set(newState);
            },
			updatePattern(status, value) {
				this.$firebaseRefs.status.child('pattern').set(value);
			}
		}
	}
</script>

<style scoped>
    input[type=range] {
        -webkit-appearance: none;
        margin: 18px 0;
        width: 100%;
    }

    input[type=range]:focus {
        outline: none;
    }

    input[type=range]::-webkit-slider-runnable-track {
        width: 100%;
        height: 8.4px;
        cursor: pointer;
        animate: 0.2s;
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        background: #3071a9;
        border-radius: 1.3px;
        border: 0.2px solid #010101;
    }

    input[type=range]::-webkit-slider-thumb {
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        border: 1px solid #000000;
        height: 36px;
        width: 16px;
        border-radius: 3px;
        background: #ffffff;
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: -14px;
    }

    input[type=range]:focus::-webkit-slider-runnable-track {
        background: #367ebd;
    }

    input[type=range]::-moz-range-track {
        width: 100%;
        height: 8.4px;
        cursor: pointer;
        animate: 0.2s;
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        background: #3071a9;
        border-radius: 1.3px;
        border: 0.2px solid #010101;
    }

    input[type=range]::-moz-range-thumb {
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        border: 1px solid #000000;
        height: 36px;
        width: 16px;
        border-radius: 3px;
        background: #ffffff;
        cursor: pointer;
    }

    input[type=range]::-ms-track {
        width: 100%;
        height: 8.4px;
        cursor: pointer;
        animate: 0.2s;
        background: transparent;
        border-color: transparent;
        border-width: 16px 0;
        color: transparent;
    }

    input[type=range]::-ms-fill-lower {
        background: #2a6495;
        border: 0.2px solid #010101;
        border-radius: 2.6px;
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    }

    input[type=range]::-ms-fill-upper {
        background: #3071a9;
        border: 0.2px solid #010101;
        border-radius: 2.6px;
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    }

    input[type=range]::-ms-thumb {
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        border: 1px solid #000000;
        height: 36px;
        width: 16px;
        border-radius: 3px;
        background: #ffffff;
        cursor: pointer;
    }

    input[type=range]:focus::-ms-fill-lower {
        background: #3071a9;
    }

    input[type=range]:focus::-ms-fill-upper {
        background: #367ebd;
    }
</style>

<!--<style>-->
<!--#app {-->
<!--font-family: 'Avenir', Helvetica, Arial, sans-serif;-->
<!-- -webkit-font-smoothing: antialiased;-->
<!-- -moz-osx-font-smoothing: grayscale;-->
<!--text-align: center;-->
<!--color: #2c3e50;-->
<!--margin-top: 60px;-->
<!--}-->

<!--h1, h2 {-->
<!--font-weight: normal;-->
<!--}-->

<!--ul {-->
<!--list-style-type: none;-->
<!--padding: 0;-->
<!--}-->

<!--li {-->
<!--display: inline-block;-->
<!--margin: 0 10px;-->
<!--}-->

<!--a {-->
<!--color: #42b983;-->
<!--}-->
<!--</style>-->


// WEBPACK FOOTER //
// src/App.vue